<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="700px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="120px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-form-item label="年检提醒天数" prop="ReminderDays">
            <div style="width: 100%; display: flex; align-items: center">
              <el-input
                v-model="form.ReminderDays"
                placeholder="请输入年检提醒天数"
              ></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import Token from '@/utils/cache/TokenCache.js'
import { mapState } from 'vuex'

export default {
  name: 'ReminderDaysForm',
  data() {
    return {
      title: '',
      disabled: false,
      moment,
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      State: null,
      row: {},
      form: {
        ReminderDays: '',
      },
      Imgs: [],
      rules: {
        ReminderDays: [
          { required: true, message: '请输入年检提醒天数', trigger: 'blur' },
        ],
      },
      drawer: false,
    }
  },
  props: {},
  methods: {
    close() {
      this.drawer = false
    },
    mounted() {},
    created() {},
    computed: {
      ...mapState(['userInfo']),
    },
    watch: {},
    openForm(title) {
      this.drawer = true
      this.form = {
        ReminderDays: '',
      }

      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      this.getInfo()
    },
    getInfo() {
      this.loading = true
      this.$http
        .post('/Base/Base_ReminderDays/GetFirstTheData', {})
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data || {}
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }

        this.loading = true

        this.$http
          .post('/Base/Base_ReminderDays/SaveData', {
            ...this.form,
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
